const dependentTemplate = () => {
    return {
        income: 0
    };
};

// Initial State
const state = {
    deceasedIncome: 0,
    dependants: [],
    multiplicand: 0,
    total: 0,
};

const types = {
    SET_VALUE: 'SET_VALUE',
    CREATE_DEPENDANT: 'CREATE_DEPENDANT',
    UPDATE_DEPENDANT: 'UPDATE_DEPENDANT',
    DELETE_DEPENDANT: 'DELETE_DEPENDANT',
    UPDATE_MULTIPLICAND: 'UPDATE_MULTIPLICAND',
    RESET: 'RESET',
};

// Getters
const getters = {
    getMultiplicand: state => {
        if (!state.multiplicand || state.multiplicand === 0) {
            return state.dependants.length > 1 ? 75 : 66.6;
        }
        return state.multiplicand;
    },
    dependantIncome: state => index => state.dependants[index].income,
    getValue: state => key => state[key],
    countDependants: state => state.dependants.length,
    totalDependantIncome: state => {
        return Number(state.dependants.reduce((income, dependant) => {
            return income + dependant.income;
        }, 0));
    }
};

// Actions
const actions = {
    setValue({commit, dispatch}, {key, value}){
        commit(types.SET_VALUE, {key, value});
        return dispatch('calculateTotal');
    },
    createDependant({commit}) {
        commit(types.CREATE_DEPENDANT);
    },
    deleteDependant({commit, dispatch}, index) {
        commit(types.DELETE_DEPENDANT, index);
        return dispatch('calculateTotal');
    },
    updateDependant({commit}, {index, value}) {
        commit(types.UPDATE_DEPENDANT, {index, value});
    },
    calculateTotal({commit, getters, state}){
        commit(types.SET_VALUE, {
            key: 'total',
            value: (state.multiplicand / 100) * (getters['totalDependantIncome'] + getters['getValue']('deceasedIncome')) - getters['totalDependantIncome']
        });
    },
    updateMultiplicand({commit, dispatch}, value) {
        commit(types.UPDATE_MULTIPLICAND, value);
        return dispatch('calculateTotal');
    },
    reset({ commit }) {
        commit(types.RESET);
    },
};

// Mutations
const mutations = {
    [types.SET_VALUE](state, {key, value}) {
        state[key] = value;
    },
    [types.CREATE_DEPENDANT](state) {
        state.dependants.push(dependentTemplate());
    },
    [types.DELETE_DEPENDANT](state, index) {
        state.dependants.splice(index, 1);
    },
    [types.UPDATE_DEPENDANT](state, {index, value}){
        state.dependants[index].income = value;
    },
    [types.UPDATE_MULTIPLICAND](state, value) {
        state.multiplicand = value;
    },
    [types.RESET](state) {
        state.deceasedIncome = 0;
        state.dependants = [];
        state.multiplicand = 0;
        state.total = 0;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/dependency.js